import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Startup world, Y U SUCK AT MOTIVATE?",
  "description": "",
  "published": "2012-03-09T00:00:00.000Z",
  "redirect_from": ["/blog/startup-world-y-u-suck-at-motivate/swizec/3886"],
  "categories": "Angelo Dundee, George Foreman, Motivation, Muhammad, Muhammad Ali, Steve Jobs, Sugar Ray Leonard, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The startup world is awash with truly inspirational stories and speeches, arguably the best of which is `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=UF8uR6Z6KLc"
      }}>{`Steve Jobs' Stanford Commencement Speech`}</a>{`.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.rottentomatoes.com/celebrity/muhammad_ali"
        }}><img parentName="a" {...{
            "src": "https://swizec.com/blog/wp-content/uploads/2012/03/11968304_gal3.jpg",
            "alt": "Muhammad Ali",
            "title": "Muhammad Ali"
          }}></img></a></li>
    </ul>
    <p>{`The world of sports, also, is awash with inspirational stories and speeches.`}</p>
    <p>{`But athletes have something the startup world lacks - motivation. That thing a trainer tells you before a big match to pump you up, to make you want to win, that burst of immediate motivation you need to overcome your own limits and win.`}</p>
    <p>{`Watch any movie about sports, at one point the hero will want to pussy out, defeated by their own body. Somebody will give them a passionate motivational speech and the hero triumphs. `}<em parentName="p">{`Emotion`}</em>{`. `}<em parentName="p">{`Power. Glory.`}</em></p>
    <p>{`Startuppers ... well, when somebody flounders, we give them advice. Weak, wimpy, `}<em parentName="p">{`advice.`}</em>{` Fuck emotion right? Fuck passion, passion isn't something you `}<em parentName="p">{`have`}</em>{` passion is something you `}<strong parentName="p">{`talk about having`}</strong>{`.`}</p>
    <p>{`Screw you.`}</p>
    <p>{`Inspiration is good! Inspiration is great! But before doing that important sales pitch, before walking into that VC's office, before tackling that bug in your code, before quitting your job to do your own thing ... that's when you need `}<em parentName="p">{`motivation`}</em>{`.`}</p>
    <p>{`I could hypothesize for hours about why athletes are so great at motivation and startuppers suck ... maybe immediate goals are easier to define, perhaps being pumped and ready to kill doesn't benefit us.`}</p>
    <p>{`But you know what? None of that matters.`}</p>
    <p>{`Before your next coding session, before that important 5 minute pitch, listen to these! Last night they helped me `}<em parentName="p">{`destroy`}</em>{` 300 SQL queries for a request and shave off 5 seconds of load time.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=V6xLYt265ZM",
        "title": "HOW GREAT I AM [unembeddable]"
      }}>{`HOW GREAT I AM `}{`[`}{`unembeddable`}{`]`}</a></p>
    <lite-youtube {...{
      "videoid": "Obo6xCAHIG8",
      "videostartat": "0"
    }}></lite-youtube>
    <lite-youtube {...{
      "videoid": "yX39J_YyKbs",
      "videostartat": "0"
    }}></lite-youtube>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://zakhomuth.com/sad-tired-and-alone-my-ongoing-battle-with-st-39237"
        }}>{`Sad, Tired, and Alone: My Ongoing Battle With Startup Depression`}</a>{` (zakhomuth.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://epodcastnetwork.com/energizing-your-group-with-a-motivational-speech/"
        }}>{`Energizing Your Group with a Motivational Speech`}</a>{` (epodcastnetwork.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://booksandbabbling.wordpress.com/2012/03/08/getting-motivated/"
        }}>{`Getting motivated`}</a>{` (booksandbabbling.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://juangreatleap.com/2011/12/03/selecting-the-right-lightbulb-evaluating-startup-ideas-part-i/"
        }}>{`ENSURING YOUR STARTUP IDEA DOESN'T SUCK, Part 1`}</a>{` (juangreatleap.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.humbledmba.com/how-to-find-a-business-cofounder-that-doesnt"
        }}>{`How to find a business cofounder that doesn't suck`}</a>{` (humbledmba.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://upfrontmenblog.wordpress.com/2012/03/06/the-essential-keys-to-self-improvement-and-motivation/"
        }}>{`The Essential Keys to Self-Improvement and Motivation`}</a>{` (upfrontmenblog.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=75f57aef-c2be-43cb-93a0-e073cd328e54",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      